/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { History, Location } from 'history';
import { Router, withRouter } from 'react-router-dom';
import { addLeadingSlash, stripBasename, stripTrailingSlash } from './utils';
import { NestedBrowserRouterProps } from './models/index';

export const nestedHistory = (history: History, basename: string) => {
    const strippedBasename = basename ? stripTrailingSlash(addLeadingSlash(basename)) : '';

    return {
        ...history,
        location: {
            ...history.location,
            pathname: stripBasename(history.location.pathname, strippedBasename),
        },
        createHref: (location: Location): string => strippedBasename + history.createHref(location),
        push: (path: string | { pathname: string; state: any }): void => {
            if (typeof path === 'string') {
                return history.push(strippedBasename + path);
            }
            return history.push(strippedBasename + path.pathname, path.state);
        },
        replace: (path: string | { pathname: string; state: any }): void => {
            if (typeof path === 'string') {
                return history.replace(strippedBasename + path);
            }
            return history.replace(strippedBasename + path.pathname, path.state);
        },
        listen: (func: any): any =>
            history.listen((location: any) =>
                func({
                    ...location,
                    pathname: stripBasename(location.pathname, strippedBasename),
                }),
            ),
    };
};

const NestedBrowserRouter: React.FC<NestedBrowserRouterProps> = ({
    history,
    basename,
    children,
    ...props
}: NestedBrowserRouterProps) => {
    return (
        <Router history={nestedHistory(history, basename)} {...props}>
            {children}
        </Router>
    );
};

export default withRouter(NestedBrowserRouter);
